import React, { FC } from 'react';
import {
  useFormContext,
  Controller,
  ControllerRenderProps,
  FieldValues,
} from 'react-hook-form';
import { Switch, Col, Row } from 'antd';
import styles from './rhfSwitch.module.scss';
import { SwitchComponentProps } from 'shared/components/SwitchComponent';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import { SwitchLabelPosition } from 'enums/FieldTypeEnums';

const RHFSwitch: FC<SwitchComponentProps> = props => {
  const { name, label, disabled, onChange, labelPosition, ...remainingProps } =
    props;
  const { control } = useFormContext();

  const handleOnChange =
    (
      field: ControllerRenderProps<FieldValues, string>
    ): SwitchChangeEventHandler =>
    (checked, e) => {
      field.onChange(checked);
      onChange?.(checked, e);
    };

  const isLeftLabel = label && labelPosition === SwitchLabelPosition.LEFT;

  const switchLabel = <Col className={styles.label}>{label}</Col>;

  return (
    <Controller
      name={name ?? ''}
      control={control}
      render={({ field }) => (
        <Row align="middle" gutter={[5, 10]}>
          {isLeftLabel ? switchLabel : null}
          <Col>
            <Switch
              {...field}
              onChange={handleOnChange(field)}
              checked={field?.value}
              {...remainingProps}
            />
          </Col>
          {!isLeftLabel ? switchLabel : null}
        </Row>
      )}
    />
  );
};

export default RHFSwitch;
